module.exports = __webpack_public_path__ + "media/images/lp_play_button_image-3d3072064ca3145ad07a0aa22c058ed4.webp";